"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var DropdownMenu = __importStar(require("@radix-ui/react-dropdown-menu"));
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var StyledDropdownItem = (0, stitches_config_1.styled)(DropdownMenu.Item, {
    gap: "10px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "12px",
    cursor: "pointer",
    "&:hover": {
        background: "#EDEDED",
        outline: "none",
        borderRadius: stitches_config_1.theme.shape.borderRadius,
    },
});
var FlexText = (0, stitches_config_1.styled)(Text_1.Text, {
    flex: 1,
});
var EndAdornment = (0, stitches_config_1.styled)("div", {
    marginLeft: "auto",
});
var className = "dropdown-item";
function DropdownItem(props) {
    var text = props.text, startIcon = props.startIcon, endIcon = props.endIcon, otherProps = __rest(props, ["text", "startIcon", "endIcon"]);
    return ((0, jsx_runtime_1.jsxs)(StyledDropdownItem, __assign({}, otherProps, { className: "".concat(className, " ").concat(props.className) }, { children: [startIcon && startIcon, (0, jsx_runtime_1.jsx)(FlexText, __assign({ variant: "text-sm-plus" }, { children: text })), endIcon && (0, jsx_runtime_1.jsx)(EndAdornment, { children: endIcon })] })));
}
exports.DropdownItem = DropdownItem;
DropdownItem.toString = function () { return ".".concat(className); };
//# sourceMappingURL=DropdownItem.js.map